import * as React from "react";
import { SVGProps } from "react";

const Enzyme = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="logo-circle_svg__e5ojfxdzkgl71"
    className="flex-none w-40 md:w-64 lg:w-72 xl:w-96 h-40 md:h-64 lg:h-72 xl:h-96 max-w-full"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 473 470"
    {...props}
  >
    <style>
      {
        "@keyframes e5ojfxdzkgl73_to__to{0%,60%{transform:translate(299.623519px,330.25237px)}}@keyframes e5ojfxdzkgl74_to__to{0%,35%{transform:translate(168.927002px,296.314011px)}77.5%{transform:translate(365.96632px,313.012259px)}}@keyframes e5ojfxdzkgl75_to__to{0%{transform:translate(251.5px,76.5px)}47.5%{transform:translate(119.027238px,134.853682px)}}"
      }
    </style>
    <defs>
      <linearGradient
        id="logo-circle_svg__e5ojfxdzkgl73-fill"
        x1={156.478}
        x2={-180.436}
        y1={0}
        y2={19.723}
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop
          id="logo-circle_svg__e5ojfxdzkgl73-fill-0"
          offset="0%"
          stopColor="#6F56FD"
        />
        <stop
          id="logo-circle_svg__e5ojfxdzkgl73-fill-1"
          offset="100%"
          stopColor="#00CABE"
        />
        <stop
          id="logo-circle_svg__e5ojfxdzkgl73-fill-2"
          offset="100%"
          stopColor="#00CABE"
        />
      </linearGradient>
      <linearGradient
        id="logo-circle_svg__e5ojfxdzkgl74-fill"
        x1={-186.115}
        x2={-248.237}
        y1={94.502}
        y2={-17.301}
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop
          id="logo-circle_svg__e5ojfxdzkgl74-fill-0"
          offset="0%"
          stopColor="#42F4CA"
        />
        <stop
          id="logo-circle_svg__e5ojfxdzkgl74-fill-1"
          offset="100%"
          stopColor="#5D89F8"
        />
      </linearGradient>
      <linearGradient
        id="logo-circle_svg__e5ojfxdzkgl75-fill"
        x1={175.809}
        x2={-202.597}
        y1={0}
        y2={23.239}
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop
          id="logo-circle_svg__e5ojfxdzkgl75-fill-0"
          offset="0%"
          stopColor="#6F56FD"
        />
        <stop
          id="logo-circle_svg__e5ojfxdzkgl75-fill-1"
          offset="100%"
          stopColor="#00CABE"
        />
        <stop
          id="logo-circle_svg__e5ojfxdzkgl75-fill-2"
          offset="100%"
          stopColor="#00CABE"
        />
      </linearGradient>
      <filter
        id="logo-circle_svg__e5ojfxdzkgl73-filter"
        width="600%"
        height="600%"
        x="-400%"
        y="-400%"
      >
        <feGaussianBlur
          id="logo-circle_svg__e5ojfxdzkgl73-filter-blur-0"
          result="result"
          stdDeviation="40,40"
        />
      </filter>
      <filter
        id="logo-circle_svg__e5ojfxdzkgl74-filter"
        width="600%"
        height="600%"
        x="-400%"
        y="-400%"
      >
        <feGaussianBlur
          id="logo-circle_svg__e5ojfxdzkgl74-filter-blur-0"
          result="result"
          stdDeviation="40,40"
        />
      </filter>
      <filter
        id="logo-circle_svg__e5ojfxdzkgl75-filter"
        width="600%"
        height="600%"
        x="-400%"
        y="-400%"
      >
        <feGaussianBlur
          id="logo-circle_svg__e5ojfxdzkgl75-filter-blur-0"
          result="result"
          stdDeviation="40,40"
        />
      </filter>
    </defs>
    <g id="logo-circle_svg__e5ojfxdzkgl72">
      <g
        style={{
          animation:
            "e5ojfxdzkgl73_to__to 4000ms linear infinite alternate forwards",
        }}
        transform="translate(299.624 330.252)"
      >
        <ellipse
          id="logo-circle_svg__e5ojfxdzkgl73"
          fill='url("#logo-circle_svg__e5ojfxdzkgl73-fill")'
          stroke="none"
          strokeWidth={1}
          rx={194.39}
          ry={180.984}
          transform="translate(20.386 -18.98)"
        />
      </g>
      <g
        style={{
          animation:
            "e5ojfxdzkgl74_to__to 4000ms linear infinite alternate forwards",
        }}
        transform="translate(168.927 296.314)"
      >
        <ellipse
          id="logo-circle_svg__e5ojfxdzkgl74"
          fill='url("#logo-circle_svg__e5ojfxdzkgl74-fill")'
          stroke="none"
          strokeWidth={1}
          rx={177.032}
          ry={156.717}
          transform="translate(-8.105 7.175)"
        />
      </g>
      <g
        style={{
          animation:
            "e5ojfxdzkgl75_to__to 4000ms linear infinite alternate forwards",
        }}
        transform="translate(251.5 76.5)"
      >
        <ellipse
          id="logo-circle_svg__e5ojfxdzkgl75"
          fill='url("#logo-circle_svg__e5ojfxdzkgl75-fill")'
          stroke="none"
          strokeWidth={1}
          rx={208.93}
          ry={185.418}
          transform="translate(-13.43 11.918)"
        />
      </g>
      <mask id="logo-circle_svg__e5ojfxdzkgl76">
        <path
          id="logo-circle_svg__e5ojfxdzkgl77"
          fill="#FFF"
          fillRule="evenodd"
          stroke="none"
          strokeWidth={1}
          d="M472.626 235c0 129.787-105.801 235-236.313 235S0 364.787 0 235 105.801 0 236.313 0s236.313 105.213 236.313 235zm-225.898-90.224c0-17.86 14.478-32.338 32.338-32.338s32.339 14.478 32.339 32.339v93.097h42.282v-67.427c0-10.304 8.353-18.657 18.657-18.657s18.657 8.353 18.657 18.657v67.427h-37.314v74.778c0 11.678-9.467 21.145-21.145 21.145-11.677 0-21.144-9.467-21.144-21.145v-74.777h-64.67v94.313c0 18.547-15.036 33.583-33.583 33.583-18.547 0-33.582-15.036-33.582-33.583v-94.314h67.165v-93.098zm-109.457 30.62c0-11.678 9.467-21.145 21.144-21.145 11.678 0 21.145 9.467 21.145 21.145v62.48h-42.289v-62.48zm-27.363 121.509c15.112 0 27.363-12.251 27.363-27.363v-31.666H82.544v31.666c0 15.112 12.251 27.363 27.364 27.363zm321.469-38.516c0 11.408-9.248 20.656-20.655 20.656-11.408 0-20.655-9.248-20.655-20.656v-20.425h41.31v20.425zM61.885 196.882c-11.407 0-20.655 9.248-20.655 20.655v20.426h41.31v-20.426c0-11.407-9.247-20.655-20.655-20.655z"
          clipRule="evenodd"
        />
      </mask>
    </g>
  </svg>
);

export default Enzyme;
